import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import { 
    Container, 
    IconChange, 
    AccordionTitle, 
    AccordionBody, 
    AccordionBodyContent, 
    BtnCloseModal, 
    ImageModal,
    Center,
    Box,
    Text,
    Img,
    ImgAccordion
} from "./styles";
//Interfaces
import { PropsInterface } from "./interfaces";
//Assets
import Close from "../../assets/icons/close.svg";
import Plus from "../../assets/icons/plus.svg";
import Minus from "../../assets/icons/minus.svg";
import {  useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "../Button";
import { Modal } from "react-bootstrap";

const Accordion = ({
    bodyText,
    id,
    setVisibleQuestion,
    title,
    visibleQuestion,
    image,
    redirectToTour
}: PropsInterface
): React.ReactElement => {
    const [visibility, setVisibility] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const history = useHistory();
    const login = useSelector((state: {login: any}) => state.login);
    const pastVersions: any = JSON.parse(localStorage.getItem("versions") || "{}");

    useEffect(() => {
        if(visibleQuestion === id){
            setVisibility(true);
        } 
        
        {
            setVisibility(false);
        }
    }, [visibleQuestion])

    const handleClick = () => {
        if(visibleQuestion === id){
            setVisibility(!visibility)
        } 
        
        {
            setVisibleQuestion(id);
        }
    }

    function removeVersionTour() {
        let newArr = pastVersions[login.user.id]
            .filter((item: string) => item !== "1.0.3");

        const newArrVersions = {
            [login.user.id]: newArr
        }

        localStorage.setItem("versions", JSON.stringify(newArrVersions));
    }
    
    return(
        <Container>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
            >
                <BtnCloseModal src={Close} onClick={() => setShowModal(false)} />
                <ImageModal src={image} alt="tela-exemplo"/>
            </Modal>
            <Center onClick={handleClick}>
                <Box>
                    <AccordionTitle>{title}</AccordionTitle>
                </Box>
                <IconChange>
                    <Img src={visibility ? Minus : Plus} alt="ocultar/abrir"/>
                </IconChange>
            </Center>
            <AccordionBody visible={visibility}>
                <AccordionBodyContent>
                    <Col xs="12">
                        <Text>
                            {bodyText}    
                        </Text>
                    </Col>
                    <Col xs="12">
                        <ImgAccordion src={image} onClick={() => setShowModal(true)} alt="tela-exemplo"/>
                    </Col>
                    {
                        redirectToTour && <Col xs="6"
                            onClick={() => {
                                removeVersionTour();
                                history.push(redirectToTour)
                            }}
                        >
                            
                            <Button className="btnSeeTour">
                                Ver tutorial
                            </Button>
                        </Col>
                    }
                </AccordionBodyContent>
            </AccordionBody>
        </Container>
    )
}

export default Accordion